import React from 'react'

const Themes: Record<string, string> = {
    light: 'bg-gray-50 text-gray-600',
    gray: 'bg-gray-200 text-gray-600',
    yellow: 'bg-yellow-400 text-gray-600',
    red: 'bg-red-500 text-white',
    blue: 'bg-blue-500 text-white',
    green: 'bg-green-500 text-white',
}

type Props = {
    children: React.ReactNode
    color?: string
}

export default function Tag(props: Props) {
    let theme = Themes[props.color || 'gray']
    return <span className={`${theme} rounded px-2 py-1 mr-1`}>{props.children}</span>
}
